import { environment } from './../../environments/environment';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { Poi } from '../models/api/poi.model';
import { PoiCategory } from '../models/api/poi-category.model';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class PoiService {
  private readonly urlPois = environment.baseUrl + environment.api + '/pois';
  private readonly urlPoisCategories =
    environment.baseUrl + environment.api + '/pois/categories';
  private readonly urlUserDisplaySettings =
    environment.baseUrl + environment.api + 'users/display_settings';

  constructor(
    private httpClient: HttpClient,
    private authService: AuthService
  ) {}

  importPois(
    locations: any[],
    radius: number,
    categoryId: string
  ): Observable<Poi[]> {
    let params = new HttpParams()
      .set('radius', radius.toString())
      .set('categoryId', categoryId);

    return this.httpClient.post<Poi[]>(this.urlPois + '/import', locations, {
      headers: this.authService.getJwtAuthHeaders(),
      params,
    });
  }

  getPois(): Observable<Poi[]> {
    return this.httpClient.get<Poi[]>(this.urlPois, {
      headers: this.authService.getJwtAuthHeaders(),
    });
  }

  postPois(pois: Poi[]): Observable<any> {
    return this.httpClient.post(this.urlPois, pois, {
      headers: this.authService.getJwtAuthHeaders(),
    });
  }

  putPoi(poi: Poi): Observable<any> {
    return this.httpClient.put(this.urlPois + '/' + poi.id, poi, {
      headers: this.authService.getJwtAuthHeaders(),
    });
  }

  deletePois(ids: number[]): Observable<any> {
    let params = new HttpParams().set('ids', ids.toString());
    return this.httpClient.delete(this.urlPois, {
      headers: this.authService.getJwtAuthHeaders(),
      params,
    });
  }

  getPoisCategories(): Observable<PoiCategory[]> {
    return this.httpClient
      .get<PoiCategory[]>(this.urlPoisCategories, {
        headers: this.authService.getJwtAuthHeaders(),
      })
      .pipe(
        map((poisCategories) => {
          poisCategories.forEach((poisCategory) => {
            poisCategory.color =
              '#' +
              (poisCategory.color as number).toString(16).padStart(6, '0');
          });
          return poisCategories;
        })
      );
  }

  postPoisCategory(poisCategory: PoiCategory): Observable<any> {
    return this.httpClient.post(
      this.urlPoisCategories,
      {
        ...poisCategory,
        color: parseInt((poisCategory.color as string).slice(1), 16),
      },
      {
        headers: this.authService.getJwtAuthHeaders(),
      }
    );
  }

  putPoisCategory(poisCategory: PoiCategory): Observable<any> {
    return this.httpClient.put(
      this.urlPoisCategories + '/' + poisCategory.id,
      {
        ...poisCategory,
        color: parseInt((poisCategory.color as string).slice(1), 16),
      },
      {
        headers: this.authService.getJwtAuthHeaders(),
      }
    );
  }
  deletePoisCategories(ids: number[]): Observable<any> {
    let params = new HttpParams().set('ids', ids.toString());
    return this.httpClient.delete(this.urlPoisCategories, {
      headers: this.authService.getJwtAuthHeaders(),
      params,
    });
  }

  savePoiDisplaySettings(displaySettings: any): Observable<any> {
    return this.httpClient.post(this.urlUserDisplaySettings, displaySettings, {
      headers: this.authService.getJwtAuthHeaders(),
    });
  }
}
